/* global window */
/* global Element */

// https://crbug.com/590375
// shim for `extractForms` from chromium/src/components/autofill/ios/browser/resources/autofill_controller.js

if (typeof window !== 'undefined') {
	window.__gCrWeb = window.__gCrWeb || {};
	window.__gCrWeb.autofill = window.__gCrWeb.autofill || {};
	window.__gCrWeb.autofill.extractForms = window.__gCrWeb.autofill.extractForms || extractForms;
}

// Element.prototype.matches support
if (typeof Element !== 'undefined' && Element.prototype && !Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.matchesSelector
		|| Element.prototype.webkitMatchesSelector
		|| Element.prototype.mozMatchesSelector
		|| Element.prototype.msMatchesSelector;
}

/**
 * Scans DOM and returns a JSON string representation of forms and form
 * extraction results. This is just a wrapper around extractNewForms() to JSON
 * encode the forms, for convenience.
 *
 * @param {number} requiredFields The minimum number of fields forms must have
 *     to be extracted.
 * @return {string} A JSON encoded object with object['forms'] containing the
 *     forms data.
 */
function extractForms () {
	return JSON.stringify({
		forms: [],
	});
}